// @ts-check

import { createWidget } from "@opendash/core";



export default createWidget({
  type: "opendash-widget-bcm-gantt",
  meta: {},
  displayComponent: () => import("./component"),

  settingsComponent: null,

  presets: [
    {
      label: "bcm:widgets.gantt.name",
      description: "bcm:widgets.gantt.description",
      imageLink: require("./screenshot.png"),
      layout: [12, 8],
      widget: {
        config: {},
      },
    },
  ],
});
